// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3hu5f{height:25px}._3mbvd{display:inline-block;font-size:13px;line-height:1;text-align:center;white-space:nowrap;color:#fff;padding:.25em .5em;border-radius:10rem;background:-o-linear-gradient(315deg,#ffb660,#ff7d4d);background:linear-gradient(135deg,#ffb660,#ff7d4d);font-weight:600;vertical-align:3px}", ""]);
// Exports
exports.locals = {
	"space": "_3hu5f",
	"badge": "_3mbvd"
};
module.exports = exports;
